export default "__VITE_ASSET__1c3dbab7__"